import { useState, useCallback } from 'react';
import UserLabelModal from '@shared/components/UserLabelModal';
import { useUserLabelStore } from '@shared/hooks/useUserLabelStore';

interface Props {
  children: React.ReactNode;
}

/**
 * Gates the app until a user label is set.
 * Checks on mount (page load) — does NOT interrupt mid-session.
 * Shows blocking modal when label is missing or expired.
 */
export function UserLabelGate({ children }: Props) {
  const isExpired = useUserLabelStore((s) => s.isExpired);

  // Only check on initial mount (page load), not during active session
  const [needsLabel, setNeedsLabel] = useState(() => isExpired());

  const handleComplete = useCallback(() => {
    setNeedsLabel(false);
  }, []);

  return (
    <>
      <UserLabelModal open={needsLabel} onComplete={handleComplete} />
      {!needsLabel && children}
    </>
  );
}
